import { DataCoverageIcon, WarningIconWithContainer } from "components/molecules/DataCoverage/DataCoverageIcon";
import MultiselectDropdown from "components/molecules/MultiselectDropdown";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { DataCoverageEnums } from "../FilterSidebar.constants";
import { cloneFilters } from "../FilterSidebar.helpers";
import { MultiSelectFilterProps } from "../FilterSidebar.interface";

function DataCoverageMultiSelectFilter({ filters, setFilters }: MultiSelectFilterProps) {
    const { pathname } = useLocation();
    const page = pathname.includes("reports") ? "reports" : "buildings";

    const currentFilter = filters.dataCoverageFilter;
    const [selectedItemsMultiSelect, setSelectedItemsMultiSelect] = useState(currentFilter);

    let dropdownItems = DataCoverageEnums.slice();
    if (page === "reports") {
        dropdownItems = dropdownItems.filter((item) => !["error", "processing"].includes(item));
    }
    // Grouping warning items so they appear once in dropdown
    const warningItems: DataCoverageEnum[] = ["equipment_warning", "utility_warning", "equipment_and_utility_warning"];
    const nonWarningItems = dropdownItems.filter((item) => !warningItems.includes(item));

    const multiSelectDropdownItems = [
        ...nonWarningItems.map((item) => ({
            key: item,
            displayValue: <DataCoverageIcon identifier={item} />,
        })),
        ...(dropdownItems.some((item) => warningItems.includes(item))
            ? [
                  {
                      key: "warning_group",
                      displayValue: <WarningIconWithContainer />,
                  },
              ]
            : []),
    ];

    const isWarningGroupSelected = warningItems.some((item) =>
        selectedItemsMultiSelect?.includes(item as DataCoverageEnum)
    );

    // Transform selected items for display (replace individual warnings with group)
    const displaySelectedItems = selectedItemsMultiSelect
        ? [
              ...selectedItemsMultiSelect.filter((item) => !warningItems.includes(item)),
              ...(isWarningGroupSelected ? ["warning_group"] : []),
          ]
        : [];

    const handleSelectionChange = (keys: string[]) => {
        const hasWarningGroup = keys.includes("warning_group");
        const otherKeys = keys.filter((key) => key !== "warning_group");

        let finalSelection: DataCoverageEnum[];

        if (hasWarningGroup) {
            // If warning group is selected, include all warning items
            const availableWarningItems = warningItems.filter((item) => dropdownItems.includes(item));
            finalSelection = [...otherKeys, ...availableWarningItems] as DataCoverageEnum[];
        } else {
            finalSelection = otherKeys.filter(
                (key) => !warningItems.includes(key as DataCoverageEnum)
            ) as DataCoverageEnum[];
        }

        setSelectedItemsMultiSelect(finalSelection);
    };
    useEffect(() => {
        if (!selectedItemsMultiSelect) return;

        setFilters((prev) => {
            const copy = cloneFilters(prev);
            copy.dataCoverageFilter = selectedItemsMultiSelect as DataCoverageEnum[];
            return copy;
        });
    }, [selectedItemsMultiSelect]);

    useEffect(() => {
        setSelectedItemsMultiSelect(currentFilter);
    }, [currentFilter]);

    return (
        <div className="filter">
            <MultiselectDropdown
                items={multiSelectDropdownItems}
                selectedKeys={displaySelectedItems}
                handleChange={handleSelectionChange}
                fixedHeight={false}
            />
        </div>
    );
}

export default DataCoverageMultiSelectFilter;
